export default __webpack_public_path__ + "static/media/hht1_ani_10.81d11434.png";